import React, { useState, useEffect, useCallback } from 'react';
import { format, startOfMonth, endOfMonth, eachDayOfInterval, getDay, addMonths, subMonths } from 'date-fns';
import { api } from '../api';

const DOT_COLORS = { green: '#22c55e', red: '#ef4444' };

export default function Calendar({ userId, onDayClick }) {
  const [current, setCurrent] = useState(new Date());
  const [calData, setCalData] = useState({});
  const [loading, setLoading] = useState(false);

  const loadCalendar = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.getCalendar(userId, current.getFullYear(), current.getMonth() + 1);
      setCalData(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [userId, current]);

  useEffect(() => { loadCalendar(); }, [loadCalendar]);

  const days = eachDayOfInterval({ start: startOfMonth(current), end: endOfMonth(current) });
  const firstDow = getDay(startOfMonth(current)); // 0=Sun
  const today = format(new Date(), 'yyyy-MM-dd');

  return (
    <div className="calendar">
      <div className="calendar-nav">
        <button onClick={() => setCurrent(subMonths(current, 1))}>‹</button>
        <h3>{format(current, 'MMMM yyyy')}</h3>
        <button onClick={() => setCurrent(addMonths(current, 1))}>›</button>
      </div>
      {loading && <div className="calendar-loading">Loading…</div>}
      <div className="calendar-grid">
        {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d => (
          <div key={d} className="cal-header">{d}</div>
        ))}
        {Array.from({ length: firstDow }).map((_, i) => <div key={`empty-${i}`} />)}
        {days.map(day => {
          const dateStr = format(day, 'yyyy-MM-dd');
          const info = calData[dateStr] || { dots: [] };
          const isToday = dateStr === today;
          return (
            <div
              key={dateStr}
              className={`cal-day ${isToday ? 'today' : ''}`}
              onClick={() => onDayClick && onDayClick(dateStr)}
            >
              <span className="cal-day-num">{day.getDate()}</span>
              <div className="cal-dots">
                {info.dots.map((color, i) => (
                  <span key={i} className="cal-dot" style={{ background: DOT_COLORS[color] }} title={color} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
      <div className="calendar-legend">
        <span><span className="legend-dot" style={{background: DOT_COLORS.green}} /> All classes done</span>
        <span><span className="legend-dot" style={{background: DOT_COLORS.red}} /> Class missed</span>
      </div>
    </div>
  );
}
